import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Link, Button } from 'nallian-shared-ui/lib/components';
import { Table, Actions, Params, Menu } from 'nallian-table-builder-ui';
import {
  INFINITE_SCROLL,
  COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE,
  COMMUNITY_TAB_ACTIONS,
  COMMUNITY_DETAIL_TABS,
} from '../../constants';
import apiRoutes from '../../../../app/api/routes';
import NewType from './NewType';
import EditType from './EditType';

const IdentificationCodeTypes = ({ rootUrl }) => {
  const { t } = useTranslation();
  const { id, action, actionId } = useParams();

  return (
    <>
      <HasRight right="communities/identification-code-types/create">
        <NewType open={id && action && !actionId} id={id} />
      </HasRight>
      <HasRight right="communities/identification-code-types/update">
        <EditType open={id && action && actionId} id={id} />
      </HasRight>
      <HasRight right="communities/identification-code-types/create">
        <Link to={`${rootUrl}/${COMMUNITY_TAB_ACTIONS.NEW_IDENTIFICATION_CODE_TYPE}`}>
          <Button btnprimary icon="plus" content={t('newIdentificationCodeType')} />
        </Link>
      </HasRight>
      <Table
        url={apiRoutes.communityIdentificationCodeTypes(id)}
        infiniteScroll={INFINITE_SCROLL}
        resource={COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE}
        noResultsMessage={t('noIdentificationCodeTypesFound')}
        pageSize={50}
        noUserSettings
        resizable
        filtered
        sorted
      >
        <Actions.Link
          iconbutton
          width="2.5rem"
          icon="eye"
          align="center"
          hasRight="communities/identification-code-types/update"
          url={`/communities/edit/${id}/${COMMUNITY_DETAIL_TABS.IDENTIFICATION_CODE_TYPES}/${COMMUNITY_TAB_ACTIONS.EDIT_IDENTIFICATION_CODE_TYPE}/:id`}
        />
        <Params.String
          grow
          label="name"
          name="type.name"
          width="16rem"
          minWidth="16rem"
          noFilter
          noSort
        />
        <Params.String grow label="tag" name="type.tag" width="8rem" noFilter noSort />
        <Params.Bool name="isRequired" width="8rem" minWidth="8rem" noFilter noSort grow />
        <Menu width="3.5rem" align="center" hasRight="communities/identification-code-types/delete">
          <Actions.Delete
            url={apiRoutes.communityIdentificationCodeTypes(id, ':id')}
            confirmMessage={t('areYouSureRemoveIdentificationCodeType')}
          />
        </Menu>
      </Table>
    </>
  );
};

IdentificationCodeTypes.propTypes = { rootUrl: PropTypes.string.isRequired };

export default IdentificationCodeTypes;
